import { DashboardLayout } from "components/layout/DashboardLayout";
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useState, useEffect } from "react";
import { useTableColumns } from './hooks/useTableColumns';
import "assets/scss/billingPortal/modules/reporting/storeReport.scss";
import useReporting from "dataflow/billingPortal/actions/useReporting.actions";
import { isArrayNotEmpty, getTotalCountFromHeader } from "functions";
import { SubmenuTooltip } from "components/informational/SubmenuTooltip";
import { MoreButton } from "components/buttons/MoreButton";
import ic_export from "assets/images/ic_export.svg";
import useExportData from './hooks/useExportData';

export default function StoreReport() {

    const [isExporting, setIsExporting] = useState();

    const { 
        getStoreReport_requesting, storeReport, storeReportHeaders,
        getFullStoreReport_requesting, fullStoreReport
    } = useCustomSelector("reporting");

    const {
        getStoreReport, getFullStoreReport
    } = useReporting();

    const columns = useTableColumns();

    // handle export
    const exportData = useExportData();
    useEffect(() => {
        if (isExporting && !getFullStoreReport_requesting && isArrayNotEmpty(fullStoreReport))
            exportData(fullStoreReport);
    }, [getFullStoreReport_requesting]);

    return (
        <DashboardLayout
            headerTitle={"Store Report"}

            bodyClassName={"store-report"}
            body={(
                <GeneralTable
                    className={"store-report__table"}
                    columns={columns}
                    data={isArrayNotEmpty(storeReport) ? storeReport : []}

                    getTableData={getStoreReport}
                    pageSize={100}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>

                                        {/* More Actions */}
                                        <SubmenuTooltip
                                        buttonClassName={"top-section__more-actions"}
                                        menuItems={[
                                            {
                                                icon: ic_export,
                                                label: "Export",
                                                onClick: () => {
                                                    setIsExporting(true);
                                                    getFullStoreReport();
                                                },
                                            }
                                        ]}
                                    >
                                        <MoreButton
                                            className={"more-actions__icon-wrapper"}
                                            iconClassName={"icon-wrapper__icon"}
                                        />
                                    </SubmenuTooltip>
                                </div>
                            </div>
                        );
                    }}
                    isTableDataLoading={getStoreReport_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(storeReportHeaders)}

                    isColumnResizeable isAllColumnWidthEqual
                    isTableOddRowsDarken
                />
            )}
        />
    );
}